<template>
  <div class="detail-padding padding-nav">
    <el-button
      @click="goback"
      type="text"
      class="upper"
      style="margin-bottom: 0.16rem"
      icon="el-icon-d-arrow-left"
    >Go back
    </el-button
    >
    <div class="spaceBetween" style="margin-bottom: 0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Stake Statistics</div>
      </div>
    </div>
    <div class="card_list" style="margin-bottom: 0.64rem">
      <div class="card_box">
        <p class="title">Total Staked</p>
        <p class="num1">
          <big-number :number="totalStaked"/>
          <span>UNIT</span>
        </p>
        <!-- <p class="num2">$ 609,000,000</p> -->
      </div>
      <div class="card_box">
        <p class="title">Unclaimed Rewards</p>
        <p class="num1">
          <big-number :number="totalRewards"/>
          <span>UNIT</span>
        </p>
        <!-- <p class="num2">$ 609,000,000</p> -->
      </div>
    </div>
    <div class="spaceBetween" style="margin-bottom: 0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Stake History</div>
      </div>
    </div>
    <div class="common-card is-border">
      <div class="common-card-main">
        <el-table class="common-table" ref="table" :data="tableList" v-loading="loading">
          <el-table-column type="index" label=" ">
          </el-table-column>
          <el-table-column label="Active Validators">
            <template slot-scope="{ row }">
              <!-- {{ row.delegation.validator_address }} -->
              <div class="userinfo">
                <div class="img">
                  <img v-if="row.description && row.description.pictures" :src="row.description.pictures" alt=""/>
                  <img v-else src="@/assets/image/stake/icon.png" alt=""/>
                </div>
                <span class="name">{{ (row.description && row.description.moniker) }}</span>
                <span class="web" v-if="row.description && row.description.website"
                      @click="handleOpen(row.description.website)"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Staked" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.balance && row.balance.amount"/>
              <span class="td-word-sm">UNIT</span>
            </template>
          </el-table-column>
          <el-table-column label="Rewards" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.rewards"/>
              <span class="td-word-sm">UNIT</span>
            </template>
          </el-table-column>
          <el-table-column label=" " align="right" width="400">
            <template slot-scope="{ row }">
              <el-button class="btn" @click="handleWithdraw(row)"
              >Withdraw
              </el-button
              >
              <el-button class="btn" @click="handleStake(row, 'delegate')"
              >Stake
              </el-button
              >
              <el-button class="btn" @click="handleStake(row, 'undelegate')"
              >Unstake
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total.sync="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList()"
        />
      </div>
    </div>
    <StakeDia ref="StakeDia" @success="getList"></StakeDia>
    <WithdrawDia ref="WithdrawDia" @success="getList"></WithdrawDia>
  </div>
</template>

<script>
import {
  profileList,
  profileRewards,
  poolVal,
  alloutstandingRewards,
  getUserInfo,
  getidentity,
} from "@/api/stake/stake.js";
import {changeAddress} from "@/api/stake/base.js";
import StakeDia from "@/views/stake/activeValidators/StakeDia.vue";
import WithdrawDia from "@/views/stake/profile/WithdrawDia.vue";

export default {
  components: {StakeDia, WithdrawDia},
  data() {
    return {
      loading: false,
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      userAddress: undefined,
      tableList: [
        /*{
          rewards: "1",
        },*/
      ],
      totalStaked: 0,
      totalRewards: 0,
    };
  },
  created() {
    if (this.getToken()) {
      this.getUserAddress().then((res) => {
        this.getPoolVal();
        this.getAllRewards();
        this.getList();
      });
    } else {
      this.$message.warning("You must sign in to the wallet to view this page!");
    }
  },
  methods: {
    getUserAddress() {
      return new Promise((resolve, reject) => {
        changeAddress({
          account: this.$store.getters.metaMaskObj.account,
        })
          .then((res) => {
            this.userAddress = res.result.cosmosAccount;
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });
    },
    getPoolVal() {
      poolVal(this.userAddress).then((res) => {
        this.totalStaked = res.pool.bonded_tokens;
      });
    },
    getAllRewards() {
      alloutstandingRewards(this.userAddress).then((res) => {
        if (res.total.length > 0) {
          this.totalRewards = res.total && res.total[0].amount;
        } else {
          this.totalRewards = 0;
        }
      });
    },
    getList() {
      this.loading = true;
      let params = {
        limit: this.queryParams.pageSize,
        offset: this.queryParams.page,
      };
      profileList(params, this.userAddress)
        .then((res) => {
          let list = res.delegation_responses || [];
          let promiseList = [];
          list.forEach((item, i) => {
            console.log(item.delegation.delegator_address);
            promiseList.push(this.handleGetRewards(item), this.getUserInfo(item));
          });
          Promise.all(promiseList).then((result) => {

            this.tableList = list;
            this.$nextTick(() => {
              this.$refs.table.doLayout()
            })
          });
          this.queryParams.total = Number(res.pagination.total) || 0;
          this.getAllRewards();
          this.getPoolVal();
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    getUserInfo(row) {
      return new Promise((resvloe, reject) => {
        if (row.delegation && row.delegation.validator_address) {
          getidentity(row.delegation.validator_address).then((res) => {
            this.$set(row, "description", res.validator.description);
            this.getUserImg(row).then(res => {
              resvloe()
            })
            // this.$set(row.description,'pictures',null)
          }).catch(() => {
            reject()
          })
        }

      });
    },
    getUserImg(row) {
      return new Promise((resvloe, reject) => {
        if (row.description && row.description.identity) {
          getUserInfo(row.description.identity).then((res) => {
            if (res.them && res.them.length > 0) {
              this.$set(row.description, "pictures", res.them[0].pictures.primary.url);
              // this.$set(row.description,'pictures',null)
            }
            resvloe()
          }).catch(() => {
            this.$set(row.description, "pictures", null);
            resvloe()
          })
        } else {
          this.$set(row.description, "pictures", null);
          resvloe()
        }
      });
    },
    handleGetRewards(row) {
      return new Promise((resvloe, reject) => {
        profileRewards(row.delegation.delegator_address, row.delegation.validator_address)
          .then((res) => {
            row.rewards = res.rewards.length !== 0 ? res.rewards[0].amount : 0;
            resvloe(row);
          })
          .catch((err) => {
            reject();
          });
      });
    },
    handleStake(row, type) {
      this.$refs.StakeDia.show({...row, validator_address: row.delegation.validator_address}, type);
    },
    handleWithdraw(row) {
      this.$refs.WithdrawDia.show(row);
    },
    goback() {
      this.$router.push("/Stake/activeValidators");
    },
    handleOpen(url) {
      window.open(url, '_blank')
    },
  },
};
</script>
<style scoped lang="scss">
.userinfo {
  display: flex;
  gap: 0.1rem;
  margin-top: 0.05rem;

  .img {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .name {
    font-size: 0.2rem;
    font-weight: 500;
    font-family: PlusJakartaDisplay-Medium;
    color: #ffffff;
    line-height: 0.28rem;
  }

  .web {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 0.17rem;
    background: url("~@/assets/image/stake/web.png") no-repeat center #efefef;
    cursor: pointer;
  }
}

.card_list {
  display: flex;
}

.card_box {
  width: 4.8rem;
  height: 1.98rem;
  background: #001a49;
  border-radius: 0.16rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
  margin-right: 0.64rem;
  padding-top: 0.24rem;
  padding-left: 0.36rem;
  box-sizing: border-box;
  overflow: hidden;

  p {
    margin: 0;
  }

  .title {
    font-size: 0.22rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.24rem;
    padding-left: 0.3rem;
    background: url("~@/assets/image/stake/img1.png") no-repeat left center;
    background-size: contain;
    margin-bottom: 0.48rem;
  }

  .num1,
  .num2 {
    padding-left: 0.3rem;
  }

  .num1 {
    font-size: 0.32rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.38rem;
    margin-bottom: 0.15rem;

    span {
      font-size: 0.16rem;
      color: #aaaaaa;
    }
  }

  .num2 {
    font-size: 0.18rem;
    color: #aaaaaa;
  }
}

.card_box:last-child .title {
  background: url("~@/assets/image/stake/img2.png") no-repeat left center;
  background-size: contain;
}

// .common-table {
//   /deep/ &.el-table {
//     font-size: 0.16rem;
//     background: #f5f5f5;

//     .el-table__header-wrapper th {
//       background: #f5f5f5;
//       color: #aaaaaa;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//     }

//     th.is-leaf {
//       border-bottom: none;
//     }

//     td {
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1f1f1f;
//       line-height: 0.24rem;
//       background: #f5f5f5;
//       border-bottom: none;
//     }

//     &::before {
//       background: none;
//     }
//   }

//   .td-word-sm {
//     font-size: 0.16rem;
//     font-weight: 400;
//     color: #929dad;
//     line-height: 0.19rem;
//   }
// }

.xiaohao {
  font-size: 0.15rem;
  color: #1f1f1f;

  i {
    color: #2e9571;
    margin-right: 0.06rem;
  }
}

.btn {
  width: 108px;
  height: 44px;
  background: linear-gradient(
      90deg,
      rgba(34, 91, 252, 0) 0%,
      rgba(34, 91, 252, 0.38) 67%,
      #225bfc 100%
  );
  color: #ffffff;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
</style>
